module.exports = __webpack_public_path__ + "static/media/checkin.09c1a2af.svg";